import React from "react";
import { Container, Row, Col, SearchIcon } from "shared-portal-component";
import "./SearchInput.scss";

const SearchInput: React.FC<React.InputHTMLAttributes<HTMLInputElement>> = ({
  placeholder = "Search for a user",
  value,
  onChange,
  className = "",
  ...rest
}) => (
  <Container fluid className={`custom-search-input-container ${className}`}>
    <Row spacing="none" align="center">
      <Col>
        <input
          className="custom-search-input__field"
          type="text"
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          {...rest}
        />
      </Col>
      <Col size="content">
        <span className="custom-search-input__icon">
          <SearchIcon />
        </span>
      </Col>
    </Row>
  </Container>
);

export default SearchInput;
